<template>
  <div data-app class="uk-section-">
    <preloader :is-visible="isLoading"/>

    <div class="uk-card uk-card-small uk-card-default" style="padding-bottom: 10px;">
      <div class="uk-card-header">
        <div class="uk-grid uk-flex-middle" data-uk-grid>
          <div class="uk-width-expand">
            <div class="uk-card-title">
              {{ local_page_keys.progress_report }}
            </div>
          </div>
          <div class="uk-width-auto">
            <!--        <div class="uk-text-right" style="margin-top: -25px;color: #fff;" v-if="finance.to_pay_today">-->
            <div style="color: #fff;">
              <div class="tm-background-green uk-padding-xsmall uk-border-rounded" v-if="finance.to_pay_today">
                {{ local_page_keys.to_pay }}: {{ finance.to_pay_today }}
              </div>
            </div>
          </div>
        </div>

      </div>
      <RatingTable
        :items="items"
        :loading="loadingRaw"
        :individual-fields="fields"
        :multiRow = false
        :selectOrder="selectOrder"
        :user_id = "user_id"
        choosenRole="retoucher"
        @loadMore="getMore"
        @openOrder="selectOrder"/>
    </div>

    <!--иифо диалоговое окно-->
    <md-dialog
        :md-active.sync="showDialog"
        :md-closed="true"
        :md-clicked-outside="true"
        :md-close-on-esc="true"
        class="tm-dialog-progress-report">
      <div class="uk-padding uk-position-relative tm-modal-page" style="overflow-y: scroll;">
        <a href="#" class="uk-position-top-right tm-dialog-close" @click="showDialog = false">
          <span class="material-icons">close</span>
        </a>

        <div class="uk-grid uk-flex-middle" data-uk-grid>
          <div class="uk-width-auto">
            <h4>{{ local_page_keys.order_number }}: {{ order_id }}</h4>
          </div>
          <div class="uk-width-expand">
            <div class="uk-grid uk-grid-small uk-flex-center uk-flex-middle" data-uk-grid>
              <div>
                <a href="#" :disabled="activeOrderKey <= 0"
                   class="tm-light tm-light-hover uk-button uk-button-small-padding uk-button-success" role="button"
                   data-uk-tooltip="title: Предыдущий заказ" @click="prevOrder">
                  <span class="material-icons">chevron_left</span>
                </a>
              </div>
              <div>
                <a href="#" :disabled="activeOrderKey >= (activeOrders.length-1)"
                   class="tm-light tm-light-hover uk-button uk-button-small-padding uk-button-success" role="button"
                   data-uk-tooltip="title: Следующий заказ" @click="nextOrder">
                  <span class="material-icons">chevron_right</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="uk-margin" v-if="!activeOrderReload">
          <OrderView></OrderView>
          <hr class="uk-margin-medium">
          <h4 class="uk-margin">{{local_page_keys.title_previous_orders}}:</h4>
          <prev-orders-block-for-admin :currentOrderId="order_id"></prev-orders-block-for-admin>
        </div>
      </div>
    </md-dialog>

  </div>
</template>

<script>
import Preloader from "@/pages/Dashboard/Components/Preloader";
import RatingTable from "@/pages/Dashboard/Tables/RatingTable";
import OrderView from "@/pages/Dashboard/Pages/OrderView";
import PrevOrdersBlockForAdmin from "@/pages/Dashboard/Components/Admin/PrevOrdersBlockForAdmin";
import responsiveMixin from '@/mixins/responsiveMixin';

export default {
  name: 'ProRetouchersProgressReport',
  data: () => ({
    isLoading: true,
    local_page_keys: {},
    showDialog: false,
    page: 0,
    items: [],
    moreItemsButton: true,
    order_id: null,
    loadingRaw: false,
    activeOrders: [],
    activeOrderKey: null,
    activeOrderReload: false,
    finance: {},
    fields: [
      {
        key: 'weekly-bonus',
        key_lang: 'pr_weekly_bonus',
        icon: 'percent',
        countIcons: 1,
        title: 'Weekly bonus',
        order: 10,
        role:'retoucher'
      },
      {
        key: 'total',
        icon: 'tag',
        key_lang: 'pr_number_of_orders',
        title: 'Orders',
        countIcons: 1,
        order: 20,
        role:'retoucher'
      },
      {
        key: 'number_of_rejected_orders',
        key_lang: 'pr_number_order_rejects_by_retoucher',
        icon: 'report_off',
        countIcons: 1,
        title: 'Number of rejected orders',
        withOrders: true,
        order: 110,
        role:'retoucher'
      },
    ],
    user_id: null
  }),
  components: {
    Preloader, RatingTable, OrderView, PrevOrdersBlockForAdmin
  },
  mixins: [responsiveMixin],
  methods: {
    async getMore(newRequest = false) {
      if (!this.moreItemsButton) {
        return;
      }
      this.loadingRaw = true;
      this.moreItemsButton = false;
      let error = "";
      await this.$store.dispatch('rating/ratingData', {page: this.page, new: newRequest}).catch((reason => {
        this.moreItemsButton = true;
        error = true;
      }));
      if (!error) {
        let ratingRow = await this.$store.getters['rating/ratingData'];
        this.items.push(ratingRow['data']);
        this.user_id = ratingRow['user_id'];
        this.page++;
        this.moreItemsButton = true;
      }
      this.loadingRaw = false;
    },
    async selectOrder({key, orders}) {
      if(this.isMobile) {
        return;
      }
      this.activeOrders = orders.map((order) => {
        return order.order_id ?? null;
      });
      this.activeOrderKey = key;
      let order_id = this.activeOrders[key];
      await this.openOrder(order_id);
    },
    async openOrder(order_id) {
      this.activeOrderReload = true;
      await this.$store.dispatch('order/setViewOrderId', order_id);
      this.order_id = order_id;
      this.showDialog = true;
      this.activeOrderReload = false;
      location.hash = order_id;
    },
    async nextOrder() {
      if (this.activeOrders[this.activeOrderKey + 1]) {
        await this.openOrder(this.activeOrders[this.activeOrderKey + 1]);
        this.activeOrderKey++;
      }
    },
    async prevOrder() {
      if (this.activeOrders[this.activeOrderKey - 1]) {
        await this.openOrder(this.activeOrders[this.activeOrderKey - 1]);
        this.activeOrderKey--;
      }
    },
    async setFinance() {
      await this.$store.dispatch('rating/financeData');
      this.finance = await this.$store.getters['rating/financeData'];
    }
  },
  async created() {
    this.local_page_keys = Object.assign({}, await this.$filtergetLocalisationPage('pro_retoucher_progress_report'),await this.$filtergetLocalisationPage('admin_orders_history'));
    this.isLoading = false;
    this.setFinance();
    await this.getMore();
    // if(!this.role || this.role == ''){
    //   this.role = await this.$store.getters['profile/role'];
    // }
  },

}
</script>

<style>
.uk-button-success,
.uk-button-success:hover,
.uk-button-success:focus {
  color: #fff !important;
}

.uk-drop-parent-icon {
  transition: transform .3s ease-out;
}

[aria-expanded=true] > .uk-drop-parent-icon {
  transform: rotateX(180deg)
}

.uk-table-hover > tr:hover, .uk-table-hover tbody tr:hover {
  position: relative;
  z-index: 2;
}

</style>